// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner_section_wrapper {
  width: 100%;
  height: 100vh !important;
}

.banner_section_inner_div {
  width: 100%;
  height: 100%;
  position: relative;
}

.banner_section_slider_main {
  width: 100%;
  height: 100% !important;
  position: absolute;
  z-index: 1;
  outline: none;
}

.banner_section_card > img {
  width: 100%;
  height: 100vh !important;
  object-fit: cover !important;
  outline: none;
}

.banner_section_overlay_div {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 70px;
}

.banner_section_overlay_text_1 {
  color: #fff;
  font-family: "Open Sans";
  font-size: 70px;
  font-style: normal;
  font-weight: 400;
  line-height: 127.249%;
  padding: 0 0 0 20px;
}

.banner_section_overlay_text_2 {
  color: #FFF;
font-family: "Open Sans";
font-size: 92px;
font-style: normal;
font-weight: 600;
line-height: 127.249%;
  background: #206D23;
  padding: 0 20px;
  margin: 12px 0 0 0;
}

.ShadowImg {
  width: 100%;
  position: absolute;
  z-index: 2;
  bottom: 0;
  right: 0;
  height: 100px !important;
}








@media screen and (max-width: 1200px) {

  .banner_section_wrapper {
    width: 100%;
    height: 95vh !important;
  }
 
  .banner_section_overlay_div {
    padding-left: 50px;
  }

  .banner_section_card > img {
    height: 95vh !important;
  }
  
  .banner_section_overlay_text_1 {
    font-size: 60px;
    padding: 0 0 0 20px;
  }
  
  .banner_section_overlay_text_2 {
    font-size: 70px;
    padding: 0 20px;
    margin: 12px 0 0 0;
  }
  
  .ShadowImg {
    height: 70px !important;
  }
  

}












@media screen and (max-width: 1024px) {

  .banner_section_wrapper {
    width: 100%;
    height: 90vh !important;
  }
 
  .banner_section_overlay_div {
    padding-left: 40px;
  }

  .banner_section_card > img {
    height: 90vh !important;
  }
  
  .banner_section_overlay_text_1 {
    font-size: 50px;
    padding: 0 0 0 12px;
  }
  
  .banner_section_overlay_text_2 {
    font-size: 60px;
    padding: 0 12px;
    margin: 12px 0 0 0;
  }
  
  .ShadowImg {
    height: 70px !important;
  }
  

}











@media screen and (max-width: 800px) {

  .banner_section_wrapper {
    width: 100%;
    height: 70vh !important;
  }
 
  .banner_section_overlay_div {
    padding-left: 20px;
  }

  .banner_section_card > img {
    height: 70vh !important;
  }
  
  .banner_section_overlay_text_1 {
    font-size: 40px;
    padding: 0 0 0 10px;
  }
  
  .banner_section_overlay_text_2 {
    font-size: 50px;
    padding: 0 10px;
    margin: 12px 0 0 0;
  }
  
  .ShadowImg {
    height: 70px !important;
  }
  
}








@media screen and (max-width: 600px) {

  .banner_section_wrapper {
    width: 100%;
    height: 50vh !important;
  }
 
  .banner_section_overlay_div {
    padding-left: 10px;
  }

  .banner_section_card > img {
    height: 50vh !important;
  }
  
  .banner_section_overlay_text_1 {
    margin-top: 50px;
    font-size: 30px;
    line-height: 36px;
    padding: 0 0 0 10px;
  }
  
  .banner_section_overlay_text_2 {
    font-size: 36px;
    padding: 0 10px;
    margin: 6px 0 0 0;
  }
  
  .ShadowImg {
    height: 40px !important;
  }
  

}










@media screen and (max-width: 450px) {

  .banner_section_wrapper {
    width: 100%;
    height: 40vh !important;
  }
 
  .banner_section_overlay_div {
    padding-left: 10px;
  }

  .banner_section_card > img {
    height: 40vh !important;
  }
  
  .banner_section_overlay_text_1 {
    margin-top: 70px;
    font-size: 26px;
    line-height: 32px;
    padding: 0 0 0 10px;
  }
  
  .banner_section_overlay_text_2 {
    font-size: 32px;
    padding: 0 10px;
    margin: 6px 0 0 0;
  }
  
  .ShadowImg {
    height: 30px !important;
  }
  

}`, "",{"version":3,"sources":["webpack://./src/components/homePage/bannerSection/bannerSection.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb,wBAAwB;AACxB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,qBAAqB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,wBAAwB;AAC1B;;;;;;;;;AASA;;EAEE;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;;AAGF;;;;;;;;;;;;;AAaA;;EAEE;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;;AAGF;;;;;;;;;;;;AAYA;;EAEE;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;AAEF;;;;;;;;;AASA;;EAEE;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;;AAGF;;;;;;;;;;;AAWA;;EAEE;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;;AAGF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');\n\n.banner_section_wrapper {\n  width: 100%;\n  height: 100vh !important;\n}\n\n.banner_section_inner_div {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.banner_section_slider_main {\n  width: 100%;\n  height: 100% !important;\n  position: absolute;\n  z-index: 1;\n  outline: none;\n}\n\n.banner_section_card > img {\n  width: 100%;\n  height: 100vh !important;\n  object-fit: cover !important;\n  outline: none;\n}\n\n.banner_section_overlay_div {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-left: 70px;\n}\n\n.banner_section_overlay_text_1 {\n  color: #fff;\n  font-family: \"Open Sans\";\n  font-size: 70px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 127.249%;\n  padding: 0 0 0 20px;\n}\n\n.banner_section_overlay_text_2 {\n  color: #FFF;\nfont-family: \"Open Sans\";\nfont-size: 92px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 127.249%;\n  background: #206D23;\n  padding: 0 20px;\n  margin: 12px 0 0 0;\n}\n\n.ShadowImg {\n  width: 100%;\n  position: absolute;\n  z-index: 2;\n  bottom: 0;\n  right: 0;\n  height: 100px !important;\n}\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1200px) {\n\n  .banner_section_wrapper {\n    width: 100%;\n    height: 95vh !important;\n  }\n \n  .banner_section_overlay_div {\n    padding-left: 50px;\n  }\n\n  .banner_section_card > img {\n    height: 95vh !important;\n  }\n  \n  .banner_section_overlay_text_1 {\n    font-size: 60px;\n    padding: 0 0 0 20px;\n  }\n  \n  .banner_section_overlay_text_2 {\n    font-size: 70px;\n    padding: 0 20px;\n    margin: 12px 0 0 0;\n  }\n  \n  .ShadowImg {\n    height: 70px !important;\n  }\n  \n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1024px) {\n\n  .banner_section_wrapper {\n    width: 100%;\n    height: 90vh !important;\n  }\n \n  .banner_section_overlay_div {\n    padding-left: 40px;\n  }\n\n  .banner_section_card > img {\n    height: 90vh !important;\n  }\n  \n  .banner_section_overlay_text_1 {\n    font-size: 50px;\n    padding: 0 0 0 12px;\n  }\n  \n  .banner_section_overlay_text_2 {\n    font-size: 60px;\n    padding: 0 12px;\n    margin: 12px 0 0 0;\n  }\n  \n  .ShadowImg {\n    height: 70px !important;\n  }\n  \n\n}\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n\n  .banner_section_wrapper {\n    width: 100%;\n    height: 70vh !important;\n  }\n \n  .banner_section_overlay_div {\n    padding-left: 20px;\n  }\n\n  .banner_section_card > img {\n    height: 70vh !important;\n  }\n  \n  .banner_section_overlay_text_1 {\n    font-size: 40px;\n    padding: 0 0 0 10px;\n  }\n  \n  .banner_section_overlay_text_2 {\n    font-size: 50px;\n    padding: 0 10px;\n    margin: 12px 0 0 0;\n  }\n  \n  .ShadowImg {\n    height: 70px !important;\n  }\n  \n}\n\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n\n  .banner_section_wrapper {\n    width: 100%;\n    height: 50vh !important;\n  }\n \n  .banner_section_overlay_div {\n    padding-left: 10px;\n  }\n\n  .banner_section_card > img {\n    height: 50vh !important;\n  }\n  \n  .banner_section_overlay_text_1 {\n    margin-top: 50px;\n    font-size: 30px;\n    line-height: 36px;\n    padding: 0 0 0 10px;\n  }\n  \n  .banner_section_overlay_text_2 {\n    font-size: 36px;\n    padding: 0 10px;\n    margin: 6px 0 0 0;\n  }\n  \n  .ShadowImg {\n    height: 40px !important;\n  }\n  \n\n}\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n\n  .banner_section_wrapper {\n    width: 100%;\n    height: 40vh !important;\n  }\n \n  .banner_section_overlay_div {\n    padding-left: 10px;\n  }\n\n  .banner_section_card > img {\n    height: 40vh !important;\n  }\n  \n  .banner_section_overlay_text_1 {\n    margin-top: 70px;\n    font-size: 26px;\n    line-height: 32px;\n    padding: 0 0 0 10px;\n  }\n  \n  .banner_section_overlay_text_2 {\n    font-size: 32px;\n    padding: 0 10px;\n    margin: 6px 0 0 0;\n  }\n  \n  .ShadowImg {\n    height: 30px !important;\n  }\n  \n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
